<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="w-100 breadCrumbsWrapper">
            <BreadCrumbsHeader currentPage="Login" />
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mb-4">
      <div class="row">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="login-wrapper p-4">
              <h2 class="modal-text">Sign In</h2>
              <div class="w-100 mt-4">
                <!-- form -->
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.username)"
                  >
                    <label class="w-100 text-gray text-left">Username</label>
                    <input
                      type="text"
                      name="username"
                      class="form-control"
                      required
                      v-model.lazy="model.username"
                    />

                    <field-messages
                      name="username"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Username is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.password)"
                  >
                    <label class="w-100 text-gray text-left">Password</label>
                    <input
                      type="password"
                      name="password"
                      class="form-control"
                      required
                      v-model.lazy="model.password"
                    />

                    <field-messages
                      auto-label
                      name="password"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Password is a required field
                      </div>
                      <div slot="password" class="error">
                        Password is invalid
                      </div>
                    </field-messages>
                  </validate>
                  <div class="w-100 my-2 error" v-if="errorMsg">
                    {{ errorMsg }}
                  </div>
                  <div class="py-2 text-center">
                    <button class="modal-default-button" type="submit">
                      Submit
                    </button>
                  </div>
                </vue-form>
                <!-- divider -->
                <div class="w-100 position-relative mt-3 mb-3">
                  <h1 class="form-title">Or</h1>
                </div>
                <div class="w-100 my-2 d-flex justify-content-center">
                  <v-facebook-login
                    app-id="390930505996364"
                    @login="FBlogin"
                    @sdk-init="handleSdkInit"
                    v-model="fbmodel"
                  ></v-facebook-login>
                </div>
                <div class="w-100 my-2 d-flex justify-content-center">
                  <!-- <button
                    v-google-signin-button="clientId"
                    class="google-signin-button"
                  >
                    Continue with Google
                  </button> -->
                  <div class="google-signin-button">
                    <div class="google-icon-wrapper">
                      <img
                        class="google-icon"
                        src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                      />
                    </div>
                    <button v-google-signin-button="clientId">
                      <p class="btn-text"><b>Sign in with google</b></p>
                    </button>
                  </div>
                </div>
                <!-- social login -->
                <!-- <div class="w-100 my-2 d-flex justify-content-center">
                  <v-facebook-login app-id="390930505996364"></v-facebook-login>
                </div> -->
                <!-- register link -->
                <div class="w-100 mt-3">
                  <router-link
                    class=""
                    :to="code ? `/register/${code}` : '/register'"
                  >
                    <div class="w-100 d-flex flex-row justify-content-center">
                      <span class="ml-2 signup-text">Sign up</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import GoogleSignInButton from "vue-google-signin-button-directive";
import VFacebookLogin from "vue-facebook-login-component";
import { mapActions } from "vuex";
export default {
  components: {
    BreadCrumbsHeader,
    VFacebookLogin,
  },
  directives: {
    GoogleSignInButton,
  },
  data() {
    return {
      formstate: {},
      errorMsg: "",
      model: {
        username: "",
        password: "",
      },
      clientId:
        "221696242612-05ehol393hfl1v05k65n2imgkp4c6nvj.apps.googleusercontent.com",
      FB: {},
      scope: {},
      fbmodel: {},
      code: this.$route.params.code,
    };
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn",
      fbSignIn: "auth/FBsignIn",
      GoogleSignIn: "auth/GoogleSignIn",
      signOutAction: "auth/signOut",
    }),
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
    },
    FBlogin(response) {
      // console.log(response);
      var vm = this;
      var body = {
        accessToken: response.authResponse.accessToken,
        expiresIn: response.authResponse.expiresIn,
      };

      vm.fbSignIn(body)
        .then(() => {
          vm.$router.replace({
            name: "home_new",
          });
          vm.errorMsg = "";
          vm.logoutFromFacebook();
        })
        .catch(function(error) {
          // vm.errorMsg = error
          // console.log("error " + JSON.stringify(error.response, null, 2));
          vm.logoutFromFacebook();
          vm.errorMsg = error.response.data.error.errors[0].message;
        });
    },
    logoutFromFacebook() {
      this.scope.logout();
    },
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    // handleCredentialResponse(response) {
    //   var vm = this;

    //   var body = {
    //     id_token: response.credential,
    //   };

    //   if (vm.code) {
    //     vm.GoogleSignIn(body)
    //       .then(() => {
    //         vm.errorMsg = "";
    //         const authToken = localStorage.getItem("token");

    //         $.ajax({
    //           type: "POST",
    //           url: "https://rtb.glueapi.io/v3/authenticate/code",
    //           contentType: "application/json; charset=utf-8",
    //           headers: {
    //             "X-AUTH-TOKEN": `${authToken}`,
    //           },
    //           data: JSON.stringify({
    //             code: vm.code,
    //           }),
    //           dataType: "json",
    //           success: function(data) {
    //             vm.$router.replace({
    //               name: "home_new",
    //             });
    //             vm.errorMsg = "";
    //           },
    //           error: function(xhr, status, error) {
    //             vm.signOut();
    //             var jsonResponse = JSON.parse(xhr.responseText);
    //             vm.errorMsg = jsonResponse.error.displayMessage;
    //           },
    //         });
    //       })
    //       .catch(function(error) {
    //         vm.errorMsg = error.response.data.error.errors[0].message;
    //       });
    //   } else {
    //     vm.GoogleSignIn(body)
    //       .then(() => {
    //         vm.$router.replace({
    //           name: "home_new",
    //         });
    //         vm.errorMsg = "";
    //       })
    //       .catch(function(error) {
    //         vm.errorMsg = error.response.data.error.errors[0].message;
    //       });
    //   }
    // },
    onSubmit: function(e) {
      e.preventDefault();
      var vm = this;

      if (vm.code) {
        vm.signIn(vm.model)
          .then(() => {
            vm.errorMsg = "";
            const authToken = localStorage.getItem("token");

            $.ajax({
              type: "POST",
              url: "https://rtb.glueapi.io/v3/authenticate/code",
              contentType: "application/json; charset=utf-8",
              headers: {
                "X-AUTH-TOKEN": `${authToken}`,
              },
              data: JSON.stringify({
                code: vm.code,
              }),
              dataType: "json",
              success: function(data) {
                // vm.$router.replace({
                //   name: "home_new",
                // });

                vm.$router.push({ name: "home_new" }).then(() => {
                  vm.$router.go();
                });

                vm.errorMsg = "";
              },
              error: function(xhr, status, error) {
                vm.signOut();
                var jsonResponse = JSON.parse(xhr.responseText);
                vm.errorMsg = jsonResponse.error.displayMessage;
              },
            });
          })
          .catch(function(error) {
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      } else {
        vm.signIn(vm.model)
          .then(() => {
            vm.$router.replace({
              name: "home_new",
            });
            vm.errorMsg = "";
          })
          .catch(function(error) {
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      }
    },
    OnGoogleAuthSuccess(idToken) {
      var vm = this;
      var body = {
        id_token: idToken,
      };

      vm.GoogleSignIn(body)
        .then(() => {
          vm.$router.replace({
            name: "home_new",
          });
          vm.errorMsg = "";
        })
        .catch(function(error) {
          // vm.errorMsg = error
          // console.log("error " + JSON.stringify(error.response, null, 2));
          vm.errorMsg = error.response.data.error.errors[0].message;
        });
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    },
    signOut() {
      this.signOutAction().then(() => {
        console.log("i");
      });
    },
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 90px 0 0;
  min-height: 80vh;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.modal-text {
  margin-top: 0;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.signup-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  background: #191919;
  border-radius: 4px;
}
.text-yellow {
  color: #f1c40f;
}
.text-black {
  color: black;
}
.text-gray {
  color: #6c757d;
}
.form-label {
  display: block;
  margin-bottom: 1em;
  font-size: 16px;
  color: black;
  text-align: left;
}
.form-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.form-control:focus {
  color: #7a7e83;
  background-color: #191919;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
.form-label > .form-control {
  margin-top: 0.5em;
}
.form-group label {
  text-align: left;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: none;
  border-bottom: 1px solid #707070;
  border-radius: unset;
  background: #191919;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 16px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 16px;
  margin-top: 4px;
}
.modal-default-button {
  background: #f1c40f;
  color: #000000;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
}
h1 {
  overflow: hidden;
  text-align: center;
}

h1:before,
h1:after {
  background-color: #f1c40f;
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 50%;
  color: #f1c40f;
}

h1:before {
  right: 0.5em;
  margin-left: -50%;
}

h1:after {
  left: 0.5em;
  margin-right: -50%;
}
.google-signin-button {
  width: 240px;
  height: 42px;
  background-color: #4285f4;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
.google-signin-button .google-icon-wrapper {
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  background-color: #fff;
}
.google-signin-button .google-icon {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.google-signin-button .btn-text {
  float: right;
  margin: 11px 11px 0 0;
  color: #fff;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Roboto";
}
.google-signin-button button {
  border: none;
  background: transparent;
  margin-left: 39px;
}
.google-signin-button:hover {
  box-shadow: 0 0 6px #4285f4;
}
.google-signin-button:active {
  background: #1669f2;
}
@media screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
